<template>
	<div class="home">
		<banner :picS="bannerS" type="video"></banner>
		<div class="widthBox">
			<div class="join">
				<titleOne en='To join in' titleurl="/join" :title="lang.title.text01"></titleOne>
				<div class="picBox">
					<banner itemType="join" jsClass="join" :picS="indexData.join_politely" :navigation="false"></banner>
				</div>
			</div>
			<div class="case">
				<titleOne en='Case sharing' titleurl="/case" id="index_1" :title="lang.title.text02"></titleOne>
				<div class="picBox" v-if="mobile">
					<bannerA :slides="1" :scale="false" :autoPlay="false" :padding="50" :list="indexData.case_sharing"></bannerA>
				</div>
				<div class="picBox" v-else>
					<bannerA :autoPlay="false" :padding="50" :list="indexData.case_sharing"></bannerA>
				</div>
			</div>
		</div>
		<div class="separate">
			<img src="@/assets/pic_04.png" alt="">
		</div>

		<div class="product">
			<titleOne en='Product center' titleurl="/product" :title="lang.menu.product"></titleOne>
			<div class="productBox">
				<div class="proTitle acea-row row-around-wrapper">
					<div v-for="(item,index) in indexData.product_center" :data-index="index" @click="proChange" :class="proIndex==index?'active':''" class="item acea-row row-center-wrapper">
						<img src="@/assets/icon_01.png" alt="">
						<div class="txt">
							<p class="name">{{item.name}}</p>
							<p class="en">{{item.enname}}</p>
						</div>
					</div>
				</div>
			</div>
			<template v-if="proIndex == index" v-for="(item,index) in indexData.product_center">
				
				<div class="picBox">
					<img :src="item.back_img" alt="">
				</div>
				<div class="rotation widthBox">
					<div class="tabs">
						<div class="item" v-for="(it,ind) in item.son" :class="proTabIndex == ind?'active':''" @click="proTabChange(ind)" :key="ind"><span>{{it.product}}</span></div>
					</div>
					<banner jsClass="indpro" @rotationIndex="getRotation" itemType="indpro" :bannerIndex="proTabIndex" :picS="item.son" :navigation="false"></banner>
				</div>
				
			</template>
			
		</div> 
		<div class="separate rotateY">
			<img src="@/assets/pic_04.png" alt="">
		</div>
		<div class="about">
			<titleOne id="index_3" titleurl="/about" en='Brand introduction' :title="lang.title.text03"></titleOne>
			<div class="aboutBox">
				<div class="widthBox aboutCont">
					<div class="aboutDetail acea-row" v-if="brandIndex==index" v-for="(item,index) in indexData.brand_introduction">
						<div class="aboutL">
							<img id="aboutLeft" :src="item.img" alt="">
						</div>
						<div class="aboutR" id="aboutRight">

							<h4>{{item.title}}<br/>{{item.entitle}}</h4>
							<p>{{item.content}}</p>
							<div class="acea-row">
								<router-link class="more" style="display: block;" :to="'/about?to=#about_1'">
									{{lang.public.more}}
								</router-link>
								<div @click="brandChange" data-type="a" :data-index="index" class="mobileBtn pr el-icon-arrow-left hidden-sm-and-up"></div>
								<div @click="brandChange" data-type="b" :data-index="index" class="mobileBtn nx el-icon-arrow-right hidden-sm-and-up"></div>
							</div>
							
						</div>
						<div @click="brandChange" data-type="a" :data-index="index" class="hidden-xs-only prev about_btn">
							<div class="btn">{{lang.public.text14}}</div>
						</div>
						<div @click="brandChange" data-type="b" :data-index="index" class="hidden-xs-only next about_btn">
							<div class="btn">{{lang.public.text15}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="separate" style="padding-top:0;">
			<img src="@/assets/pic_04.png" alt="">
		</div>
		<div class="news">
			<titleOne id="index_4" en='news information' titleurl="/news" :title="lang.menu.news"></titleOne>
			<div class="newsBox widthBox acea-row row-between-wrapper">
				<div class="item" v-for="item in indexData.news_information">
					<img :src="item.img" alt="">
					<div class="info">
						<div class="name">{{item.title}}</div>
						<p>{{item.describe}}</p>
						<router-link class="more" :to="'/news_detail?id='+item.id">
							{{lang.public.text16}} >
						</router-link>
					</div>
				</div>
			</div>
			<router-link class="moreBtn" style="display: block;" :to="'/news'">
				{{lang.public.more02}}
			</router-link>
		</div>
	</div>
</template>

<script>
	import banner from '@/components/banner.vue'
	import bannerA from '@/components/bannerA.vue'
	import titleOne from '@/components/titleOne.vue'
	export default {
		name: 'index',
		components: {
			banner,
			bannerA,
			titleOne,
		},
		computed: {
			bannerS() {
				return this.$store.state.bannerS
			},
			lang() {
				return this.$store.state.lang
			}
		},
		data() {
			return {
				proTab: [],
				proTabIndex: 0,
				indexData:{},
				brandIndex:0,
				proIndex:0,
				mobile:false
			}
		},
		created() {
			var width = document.body.clientWidth
			if(width <= 768){
				this.mobile = true
			}
		},
		mounted() {
			this.$api.get('home/index/webIndex',{}).then(res=>{
				this.indexData = res.data
			})
			var to = this.$route.query.to
			if(to){
				this.$el.querySelector(to)
			}
		},
		methods: {
			getRotation(e){
				console.log(e)
				this.proTabIndex = e
			},
			proTabChange(e) {
				this.proTabIndex = e
				console.log(this.proTabIndex)
			},
			proChange(e){
				console.log(e)
				this.proIndex = e.currentTarget.dataset.index
			},
			brandChange(e){
				var type = e.currentTarget.dataset.type
				var brandIndex = this.brandIndex
				if(type == 'a'){
					console.log(1)
					if(brandIndex > 0){
						brandIndex--
					}
				}else if(type == 'b'){
					console.log(2)
					if(brandIndex < (this.indexData.brand_introduction.length-1)){
						brandIndex++
					}
				}
				this.brandIndex=brandIndex
			}
		}
	}
</script>
<style lang="scss" scoped="scoped">
	$paddingTop:60px;
	$marginTop:50px;

	.join {
		padding-top: $paddingTop;

		.picBox {
			margin-top: $marginTop;
		}
	}

	.case {
		padding-top: $paddingTop;

		.picBox {
			margin-top: $marginTop;
			overflow: hidden;
		}
	}

	.separate {
		padding-top: $paddingTop;

		&.rotateY {
			transform: rotateY(180deg);
		}

		img {
			width: 100%;
		}
	}

	.product {
		padding-top: $paddingTop;

		.productBox {
			margin-top: $marginTop;

			.proTitle {
				.item {
					cursor: pointer;
					opacity: 0.5;
					margin: 0 0px;
					height: 140px;

					img {
						width: 62px;
						display: none;
					}

					&.active {
						opacity: 1;
						border-bottom: 2px solid #1D2A55;

						img {
							display: block;
						}
					}

					.txt {
						margin-left: 36px;
						color: #1D2A55;
						.name {
							font-size: 36px;
						}

						.en {
							font-size: 18px;
						}
					}
				}
			}
		}

		.picBox {
			img {
				width: 100%;
			}
		}

		.rotation {
			margin-top: -150px;
			border-radius: 20px;
			overflow: hidden;
			position: relative;

			.tabs {
				background: #1d2a55;
				border-radius:36px;
				background-size: 100% 100%;
				height: 72px;
				position: absolute;
				left: 50%;
				top: 36px;
				padding:0 0px;
				transform: translate(-50%, 0);
				z-index: 2;
				display: flex;

				.item {
					max-width:50%;
					text-align: center;
					color: #FFF;
					height: 72px;
					line-height: 52px;
					cursor: pointer;
					overflow: hidden;
					white-space: nowrap;
					box-sizing: border-box;
					padding:10px 5px;
					text-overflow: ellipsis;
					span{
						font-size: 22px;
						display: block;
						padding:0 6px;
					}
					&.active {
						color: #1D2A55;
						span{
							font-size: 22px;
							background: #FFF;
							border-radius:36px;
							box-shadow: 0px -3px 0 0 rgba($color: #000000, $alpha: 0.1) inset;
						}
					}
				}
			}
		}
	}

	.about {
		padding-top: $paddingTop;

		.aboutBox {
			margin-top: $marginTop;
			background-color: rgba($color: #23356E, $alpha: 0.1);

			.aboutCont {
				box-sizing: border-box;
				padding: 80px 100px;
			}

			.aboutDetail {
				position: relative;
				height: auto;

				.about_btn {
					position: absolute;
					top: 50%;
					transform: translate(0, -50%);
					width: 50px;
					height: 65px;
					background: rgba($color: #1D2A55, $alpha: 1.0);
					color: #FFF;
					box-sizing: border-box;
					font-size: 14px;
					line-height: 16px;
					display: flex;
					align-items: center;
					cursor: pointer;
					.btn {
						position: relative;
					}

					&::after {
						content: '';
						display: block;
						position: absolute;
						top: 50%;
						transform: translate(0, -50%);

						border: {
							top: 10px solid transparent;
							right: 10px solid #FFF;
							bottom: 10px solid transparent;
							left: 10px solid transparent;

						}
					}

					&.prev {
						left: -50px;
						padding-left: 30px;

						&::after {
							left: 0px;
						}
					}

					&.next {
						right: -50px;
						padding-left: 10px;
						padding-right: 20px;

						&::after {
							right: 0px;
							border: {
								right: 10px solid transparent;
								left: 10px solid #FFF;

							}
						}
					}
				}
			}

			.aboutL {
				width: 50%;

				img {
					width: 100%;
				}
			}

			.aboutR {
				width: 50%;
				box-sizing: border-box;
				padding: 140px 46px 40px 50px;
				background: #eee;
				box-shadow: 2px 2px 2px #23356E;

				h4 {
					font-size: 32px;
					color: #1D2A55;
					line-height: 48px;

				}

				p {
					margin-top: 80px;
					font-size: 20px;
					line-height: 40px;
					color: #1D2A55;
					max-height:300px;
					overflow-y: auto;
				}

				.more {
					margin-top: 80px;
					width: 180px;
					height: 56px;
					line-height: 56px;
					font-size: 20px;
					border: 2px solid #1D2A55;
					color: #1D2A55;
					text-align: center;
					border-radius: 10px;
					font-weight: bold;
					cursor: pointer;
				}
			}
		}
	}

	.news {
		padding-top: $paddingTop;

		.newsBox {
			margin-top: $marginTop;

			.item {
				flex: 1;
				background: rgba($color: #1D2A55, $alpha: 0.05);
				margin-left: 20px;

				&:first-child {
					margin-left: 0;
				}

				img {
					width: 100%;
				}

				.info {
					padding: 20px 20px;

					.name {
						font-size: 24px;
						line-height: 36px;
						color: #1D2A55;
						word-break:break-all;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;
					}

					p {
						margin-top: 10px;
						font-size: 18px;
						line-height: 24px;
						color: #1D2A55;
						word-break:break-all;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;
					}

					.more {
						color: #FFF;
						font-size: 12px;
						width: 125px;
						height: 32px;
						display: block;
						line-height: 32px;
						text-align: center;
						background: #1D2A55;
						margin-top: 20px;
					}
				}
			}
		}

		.moreBtn {
			color: #FFF;
			font-size: 20px;
			width: 160px;
			height: 40px;
			line-height: 40px;
			text-align: center;
			background: #1D2A55;
			margin: 40px auto 0 auto;
		}
	}
	
	@media screen and(max-width:768px) {
		.join{
			padding-top:15px;
			.picBox{
				margin-top:14px;
			}
		}
		.case{
			padding-top:15px;
			.picBox{
				margin-top:14px;
			}
		}
		.separate{
			padding-top:20px;
		}
		.product{
			padding-top:15px;
			.productBox{
				margin-top:14px;
				.proTitle .item{
					margin:0;
					height:auto;
					padding:10px 0;
					img{
						width:21px;
					}
					.txt{
						margin-left:10px;
						.name{
							font-size:16px;
							line-height:32px;
						}
						.en{
							font-size:10px;
						}
					}
				}
			}
			.rotation{
				margin-top:-40px;
				.tabs{
					display: none;
				}
			}
		}
		.about{
			padding-top:15px;
			.aboutBox{
				margin-top:20px;
				.aboutCont{
					padding:20px;
				}
				.aboutR{
					padding:30px 10px 10px;
					h4{
						font-size:16px;
						line-height:24px;
					}
					p{
						margin-top:10px;
						font-size:12px;
						line-height:20px;
						max-height: 110px;
					}
					.more{
						margin-top:10px;
						font-size:16px;
						width:auto;
						border:0;
						height:24px;
						line-height:24px;
						margin-right:10px;
						text-align: left;
					}
					.mobileBtn{
						display: inline-block;
						width:24px;
						height:24px;
						line-height:24px;
						font-size:18px;
						margin:10px 4px 0;
						text-align: center;
						font-weight: bold;
						color:#333;
						background:rgba(0,0,0,0.20);
					}
				}
				.aboutDetail .about_btn.prev{
					left:-20px;
				}
				.aboutDetail .about_btn.next{
					right:-20px;
				}
			}
		}
		
		.news{
			padding-top:15px;
			.newsBox{
				margin-top:20px;
				.item{
					flex:inherit;
					margin-left:0;
					margin-bottom:10px;
					.info{
						padding:10px;
						.name{
							font-size:16px;
							line-height:24px;
						}
						p{
							font-size:12px;
							line-height:20px;
						}
						.more{
							display: none;
						}
					}
				}
			}
			.moreBtn{
				margin-top:20px;
				font-size:16px;
			}
		}
	}
</style>
